module.exports = __webpack_public_path__ + "img/composer-send.62a8c14b.svg";